export default __webpack_public_path__ + "static/media/Outlined-Blue-3.a9fdfccb.png";